import { Icon } from '@iwoca/orion';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

export const StepIndicator = ({
    children,
    className
}: {
    children: React.ReactNode;
    className?: string;
}) => (
    <div
        className={twMerge(
            classNames(
                'relative z-0 box-border flex w-full justify-center py-s [&_*]:box-border',
                className
            )
        )}
        data-testid="step-indicator"
    >
        {children}
    </div>
);

export const Step = ({
    isComplete = false,
    isActive = false,
    number,
    children
}: {
    isComplete?: boolean;
    isActive?: boolean;
    number?: number;
    children?: React.ReactNode;
}) => (
    <div className="flex w-[80px] flex-col items-center justify-center text-structure-40 lg:w-[110px] [&:first-of-type>div>div:last-of-type]:hidden">
        <div
            className={twMerge(
                classNames(
                    'relative flex size-[30px] flex-col items-center justify-center rounded-full bg-structure-60',
                    { ['bg-primary-20']: isActive || isComplete },
                    {
                        ['border-3 size-[36px] border-solid border-secondary-60']:
                            isActive
                    }
                )
            )}
            data-testid="step-indicator-step"
        >
            {isComplete ? (
                <Icon
                    icon="checkCircleFilled"
                    className="z-[1] size-[30px] rounded-full bg-structure-100 [&_path]:fill-primary-20"
                    aria-hidden
                    viewBox="2 2 20 20"
                />
            ) : (
                <div className="z-[1] w-[10px] text-l font-bold text-structure-100">
                    {number}
                </div>
            )}

            {children}

            <Separator
                className={isActive || isComplete ? 'bg-primary-20' : ''}
            />
        </div>
    </div>
);

export const StepLabel = ({ children }: { children: React.ReactNode }) => (
    <div className="absolute top-full pt-s text-center text-xs lg:text-m lg:font-med">
        {children}
    </div>
);

const Separator = ({ className }: { className?: string }) => (
    <div
        className={twMerge(
            classNames(
                'absolute left-[-50px] z-[-1] h-xs w-[50px] bg-structure-80  lg:left-[-80px] lg:w-[80px]',
                className
            )
        )}
    />
);
